export default __webpack_public_path__ + "src/images/packages/kosi-forest-lodge/4498263b544aaae97ed214a263bf1fa2-4.jpg";